import { BrowserRouter, Routes, Route } from "react-router-dom";
import BookList from "./Pages/BookList";
import AddBook from "./Pages/AddBook";
import EditBook from "./Pages/EditBook";
import BookDetails from "./Pages/BookDetails";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<BookList />} />
        <Route path="/add" element={<AddBook />} />
        <Route path="/edit/:id" element={<EditBook />} />
        <Route path="/details/:id" element={<BookDetails />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
